import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface LocationOfflineIconProps extends SVGProps<SVGSVGElement> {
    className?: string;
  }

export const LocationOfflineIcon = ({ className, ...props }: LocationOfflineIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.8 16.8c-1.148 1.187-2.71 2.18-4.058 3.005a1.51 1.51 0 0 1-1.484 0C8.163 17.89 4.8 15.131 4.8 11.141c0-1.674.604-3.117 1.6-4.341M8.4 4.982A7.1 7.1 0 0 1 12 4c3.896 0 7.2 3.226 7.2 7.14 0 1.354-.389 2.57-1.024 3.66"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.5"
    />
    <path
      d="m4 4 16 16"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default LocationOfflineIcon;
